import { BrandfolderHexColors } from '../enums/colors.js';

const defaultDividerDark = {
    borderColor: BrandfolderHexColors.GrayDark
};
const defaultDividerLight = {
    borderColor: BrandfolderHexColors.GrayMedium
};
const primaryDividerDark = {
    borderColor: '#6c83d4'
};
const primaryDividerLight = {
    borderColor: BrandfolderHexColors.PurplePopsicle
};

export { defaultDividerDark, defaultDividerLight, primaryDividerDark, primaryDividerLight };
//# sourceMappingURL=divider.js.map
